module.exports = __webpack_public_path__ + "d03646e94055c3dad3b4953513258c7c.png";